import { MTReturnsWorkflowStepsProps } from '@/multi-territory/mt-types/mt-returns'
import { Box } from '@mui/material'
import { NavLink } from 'react-router'

export function MTReturnsWorkflowSteps({ steps }: MTReturnsWorkflowStepsProps) {
  return (
    <Box
      component="nav"
      aria-label="Returns workflow steps"
      sx={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        flex: 1,
        overflowX: 'auto',
        gap: '48px',
      }}
    >
      {steps.map(step => {
        const IconComponent = step.icon
        return (
          <NavLink
            key={step.key}
            to={step.route}
            style={{
              textDecoration: 'none',
              flexShrink: 0,
              position: 'relative',
            }}
            aria-label={`Navigate to ${step.label}`}
          >
            {({ isActive }) => (
              <Box
                sx={{
                  display: 'flex',
                  flexDirection: 'column',
                  alignItems: 'center',
                  px: { xs: 1, sm: 1.5, md: 2 },
                  pb: '3px',
                  cursor: 'pointer',
                  transition: 'opacity 0.2s',
                  '&:hover': { opacity: 0.8 },
                  mb:1
                }}
              >
                <IconComponent isSelected={isActive} className="w-7 h-7" />
                <Box
                  component="span"
                  sx={{
                    fontSize: 'var(--font-size-sm)',
                    whiteSpace: 'nowrap',
                    fontWeight: 500,
                    color: isActive
                      ? 'var(--forbrand-primary)'
                      : 'var(--forbrand-secondary)',
                  }}
                >
                  {step.label}
                </Box>
                <Box
                  sx={{
                    position: 'absolute',
                    bottom: 0,
                    left: 0,
                    right: 0,
                    height: '4px',
                    backgroundColor: isActive
                      ? 'var(--forbrand-color)'
                      : 'transparent',
                  }}
                />
              </Box>
            )}
          </NavLink>
        )
      })}
    </Box>
  )
}
